module.exports = __webpack_public_path__ + "static/img/2_3.e71451b6.jpg";